import type { BimActKc2OtherTotalItemData } from 'gql/graphql';
import { cnMixSpace, Radio } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

interface IBimActKc2OtherTotalNameCellRenderer extends ICellRendererParams<BimActKc2OtherTotalItemData> {
    bimUseActKC2OtherTotalInflationRequest: (workOrderSeasonId: number | null) => void;
    isVersion: boolean;
    isActionDisabled?: boolean;
    isInactive: boolean;
}

export const BimActKc2OtherTotalNameCellRenderer = (props: IBimActKc2OtherTotalNameCellRenderer) => {
    const { value, data, bimUseActKC2OtherTotalInflationRequest, isVersion, isActionDisabled, isInactive } = props;

    const radioDisabledByHasTotals = useMemo(() => data?.hasTotals === false, [data?.hasTotals]);

    const onRadioChange = useCallback(() => {
        bimUseActKC2OtherTotalInflationRequest((data?.workOrderSeasonId as number) || null);
    }, [bimUseActKC2OtherTotalInflationRequest, data?.workOrderSeasonId]);

    return data?.isInflation || value === 'Не считать инфляцию' ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {!isInactive && (
                <Radio
                    checked={data?.workOrderActiveSeasonId === data?.workOrderSeasonId}
                    size="m"
                    className={cnMixSpace({ mR: 'xs' })}
                    onChange={onRadioChange}
                    disabled={isVersion || isActionDisabled || radioDisabledByHasTotals}
                />
            )}
            {value}
        </div>
    ) : (
        value
    );
};

BimActKc2OtherTotalNameCellRenderer.displayName = 'BimActKc2OtherTotalNameCellRenderer';
